import md5 from 'crypto-js/md5'
import { config } from '@/_helpers'


export default {
  computed: {
    $_meeting_settings () {
      return window.settings.meeting
    },

    $_meeting_isAvailable () {
      return this.$_meeting_settings.available
    },

    $_meeting_eisa_isAvailable () {
      return this.$_meeting_settings.esia
    },

  },

  methods: {
    $_meeting_makeUrlForRoom (room) {
      return `${this.$_meeting_settings.host}/${room}`
    },

    $_meeting_makeEsiaUrlWithRoom (room) {
      // FIXME: Не должно быть дефолтной комнаты - пользователь должен переходить в конкретную комнату
      let backroom = room || 'new'

      let { protocol, hostname, port ='' } = window.location
      let host = `${protocol}//${hostname}${port && ':'}${port}`

      return `${config.esiaPath}/url?r=${host}/room/${backroom}?`
    },

    $_meeting_setCookieForUser (uid, fio, moderator = false, esia = false) {
      setSaltedCookie(uid, fio, moderator, esia)
    },
  }
}


let setSaltedCookie = function (uid, fio, moderator, esia) {
  let user = { uid, fio }
  if (moderator) user.m = Math.random().toString(20).substr(2, 4)
  if (esia) user.esia = 1

  let secret = `User_${uid}_is_${moderator ? 'moderator' : 'normal'}_esia_${esia ? 'yes' : 'no'}`
  user.s = md5(secret).toString().toLowerCase()

  let cookie = JSON.stringify(user)
  cookie = encodeURIComponent(cookie)
  cookie = btoa(cookie)

  // document.domain = "sudportal.ru"
  document.cookie = `${window.settings.meeting.cookie.name}=${cookie}; path=/; max-age=3600; domain=${window.settings.meeting.cookie.domain}`
}